const categoryTermStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' }
];

const categoryTermFrequency = [
  { id: 'YEARLY', name: 'Yearly' },
  { id: 'DAILY', name: 'Daily' },
  { id: 'ONCE', name: 'Once' },
  { id: 'EVERY_TIME', name: 'Every Time' },
  { id: 'NEVER', name: 'Never' }
];

export { categoryTermFrequency, categoryTermStatus };
